
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExecutiveOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branches"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardExtendedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"branches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branches"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"executiveOverview"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executive"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"netSales"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeCustomers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mealsProduced"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foodCostPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contributionMarginPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newCustomers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"renewals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"churnRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outstanding"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"previous"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"netSales"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeCustomers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mealsProduced"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foodCostPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contributionMarginPct"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"daily"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foodCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveries"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":880}};
    doc.loc.source = {"body":"query getExecutiveOverview($branches: [String], $startDate: String, $endDate: String) {\n  getDashboardExtendedData(branches: $branches, startDate: $startDate, endDate: $endDate, executiveOverview: true) {\n    executive {\n      current {\n        revenue\n        netSales\n        activeCustomers\n        activeSubscriptions\n        mealsProduced\n        deliveries\n        foodCostPct\n        contributionMarginPct\n        newCustomers\n        renewals\n        churnRate\n        refunds\n        collections\n        outstanding\n      }\n      previous {\n        revenue\n        netSales\n        activeCustomers\n        activeSubscriptions\n        mealsProduced\n        deliveries\n        foodCostPct\n        contributionMarginPct\n      }\n      daily {\n        date\n        revenue\n        foodCost\n        orders\n        customers\n        meals\n        deliveries\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getExecutiveOverview"] = oneQuery(doc, "getExecutiveOverview");
        
